import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { NiceFormItemKeys } from "../constants";

import sharedStyles from "../SharedDemoStyles.module.scss";

const REQUIRED_RULE = generateFormItemRequiredRules("NICE selection");
const REQUIRED_ID_RULE = generateFormItemRequiredRules("Campaign Id");
const NAME_LABEL = "Campaign Name";
const ID_LABEL = "NICE Campaign";
const ID_PLACEHOLDER = "NICE Campaign Id";

export function NiceFormItems(): JSX.Element {
    return (
        <>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                showFormLabel
                name={NiceFormItemKeys.niceName}
                label={NAME_LABEL}
                rules={REQUIRED_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                name={NiceFormItemKeys.niceID}
                label={ID_LABEL}
                placeholder={ID_PLACEHOLDER}
                showFormLabel
                rules={REQUIRED_ID_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
        </>
    );
}
